import countItemsInBasket from './countItemsInBasket';

export function clearBasketRequest(state) {
  const nextItems = [];

  const nextNumberOfItems = countItemsInBasket(nextItems);

  return {
    ...state,
    items: nextItems,
    numberOfItems: nextNumberOfItems,
  };
}

export function clearBasketSuccess(state) {
  return state;
}

export function clearBasketError(state, action) {
  const { items: actionItems } = action.actionParams.basket;
  const nextItems = actionItems;
  const nextNumberOfItems = countItemsInBasket(nextItems);

  return {
    ...state,
    error: action.error,
    items: actionItems,
    numberOfItems: nextNumberOfItems,
  };
}

export function clearProductWarningMessage(state, action) {
  const productWarningsMessages = Object.keys(state.productWarningsMessages)
    .reduce((result, warningSku) => {
      if (warningSku !== action.sku) {
        // eslint-disable-next-line no-param-reassign
        result[warningSku] = state.productWarningsMessages[warningSku];
      }
      return result;
    }, {});

  return {
    ...state,
    productWarningsMessages,
  };
}
